import type { ProviderInstanceId } from "@afar-research/contracts";

export const MANAGED_PROVIDER_INSTANCE_ID_PREFIX = "codex_managed_";

const MANAGED_PROVIDER_INSTANCE_ID_PATTERN =
  /^codex_managed_[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu;

/** Recognize the exact App-owned Provider Instance identity namespace. */
export function isManagedProviderInstanceId(value: string): value is ProviderInstanceId {
  return MANAGED_PROVIDER_INSTANCE_ID_PATTERN.test(value);
}
